import { render, staticRenderFns } from "./qrcode-reader.vue?vue&type=template&id=bbb9a5f2&scoped=true&"
import script from "./qrcode-reader.vue?vue&type=script&lang=js&"
export * from "./qrcode-reader.vue?vue&type=script&lang=js&"
import style0 from "./qrcode-reader.vue?vue&type=style&index=0&id=bbb9a5f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb9a5f2",
  null
  
)

export default component.exports